import { render, staticRenderFns } from "./BaiduMap.vue?vue&type=template&id=0153c7ed&scoped=true&"
import script from "./BaiduMap.vue?vue&type=script&lang=js&"
export * from "./BaiduMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0153c7ed",
  null
  
)

export default component.exports